<template>
    <div class="content">
        <center>
            <h3 style="display:inline-block">Crear Banner</h3>
            <i @click="showInfo()" class="el-icon-question help-icon"></i>
        </center> 
        <br><br>
            <div class="containerAdmin">
                <el-row :gutter="20">
                    <el-col :xs="24" :md="10" :offset="1">
                        <label class="font-weight-bold">Nombre del banner</label>
                        <el-input type="text" v-model="banner" placeholder="banner"></el-input>
                    </el-col>
                    <el-col :xs="24" :md="10" :offset="1">
                        <label class="font-weight-bold">Imagen del banner</label><br>
                        <input class="" type="file" @change="getFiles()" ref="files">
                        <img height="150" :src="this.bannerImage">
                    </el-col>                
                </el-row>                
                
                <el-row :gutter="20">                    
                    <el-col :xs="24" :md="10" :offset="1">
                        <label class="font-weight-bold">Descripción</label>
                        <el-input type="text" v-model="descripcion" name="message" placeholder="Texto que aparecerá en la imagen"></el-input>
                    </el-col>
                    <el-col :xs="24" :md="10" :offset="1">
                        <label class="font-weight-bold">Descripción en inglés</label>
                        <el-input type="text" v-model="descripcionEng" name="message" placeholder="Texto en inglés que aparecerá en la imagen"></el-input>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    
                    <el-col :xs="24" :md="10" :offset="1">
                        <input v-if="this.imageInvalid == false" style="margin-top: 10%;" @click="addBanner" value="Crear" class="btn btn-primary pill px-4 py-2">
                    </el-col>                
                </el-row>  
            </div>
    </div>
</template>

<script>
import { db, storage } from '@/firebase.js'
import moment from "moment"

export default {
    name: "Crear Banner",
    data () {
        return {
            /*variables para la info */
            messaje: 'Para poder crear un banner primero necesita especificar el nombre del mismo (no es muy importante el nombre que elija, sirve para el actualizar/update), luego seleccionar una imagen que se desea (preferiblemente de alta resolución pero optimizada, para que no se vea pixelada pero no tarde mucho en cargar), posteriormente se ingresan las descripciones en español e inglés, puesto que su página trabaja con ambos lenguajes y a continuación se presiona "Crear" para almacenarla.',
            title: 'Crear Banner',
            /*fin variables para info */
            files: [],
            banner: null,       
            bannerImage:null,
            descripcion: null,       
            descripcionEng: null,       
            banners: [],
            imageInvalid : true,
            bannersRef: db.child("banner")
        }
    },
    methods: {
        getFiles() {
            this.files = this.$refs.files.files
            if(this.files[0]['type'] != 'image/jpeg' && this.files[0]['type'] != 'image/png' && this.files[0]['type'] != 'image/jpg'){
                this.imageInvalid = true
                this.$message.error('Necesita cargar una imagen con extención png, jpeg o jpg');
            }else{
                this.imageInvalid = false
                const fileReader = new FileReader()
                fileReader.addEventListener('load', () => {
                    this.bannerImage = fileReader.result
                })
                fileReader.readAsDataURL(this.files[0])  
            }
        },    
        async addBanner() {
            const key = this.bannersRef.push().key
            try {
                const file = this.$refs.files.files[0]
                const url = await (
                    await storage.ref("banner")
                        .child(key)
                        .put(file)
                ).ref.getDownloadURL()
                const now = moment()
                const update = {
                    name: this.banner,                   
                    descripcion: this.descripcion,                   
                    descripcionEng: this.descripcionEng,                   
                    image: url,
                    createdAt: now.format("DD/MM/YYYY"),
                    createdAtUnix: now.unix() 
                }
                await this.bannersRef.child(key).set(update)                               

            } catch (ex) {
                this.failure();return;
                //return console.error(ex)
            }
            this.success();
        },
        success () {
            this.$message({
                message: 'Banner creado satisfactoriamente.',
                type: 'success'
            });
        },
        failure () {
            this.$message.error('Ha Ocurrido un error, intente de nuevo más tarde');
        },
        showInfo() {
            this.$alert(this.messaje, this.title, {
            confirmButtonText: 'OK',          
            });
        }
    }
}
</script>

<style lang="">
    .containerAdmin{
       margin-bottom: 10%;
   }
</style>



// WEBPACK FOOTER //
// Create.vue?3c9007fc